<script>
import ContactEntry from './contact-entry.vue'
import ContactNavbar from './contact-navbar.vue'
import PaginationButtons from '../pagination-buttons.vue'

export default {
  components: {ContactEntry, ContactNavbar, PaginationButtons},

  data() {
    return {
      contacts: [],
      numContacts: 0,
      page: 1,
      numPages: 0,
      search: '',
      observed: this.$storage.observed
    }
  },

  computed: {
    contactIds() { return this.observed.contactIds }
  },

  watch: {
    'observed.contactIds': function(newVal) {
      if (newVal.length > 0) this.fetchContacts()
    },
    // Incoming direct message (websocket 'posted') - refetch so the server
    // ordering (has_unread, last_post_at) is reflected while on this view.
    'observed.directMessageCounter': function() {
      this.fetchContacts(this.page)
    },
  },

  created() {
    if (this.contactIds.length) this.fetchContacts()
  },

  methods: {
    contactUrl(contact) {
      let channel = this.$storage.getDirectChannel(contact.uuid)
      if (channel) return `/community/${contact.uuid}/${channel.id}`
      return `/community/${contact.uuid}`
    },

    onSearchChanged: function (search) {
      this.search = search
      this.fetchContacts(1)
    },

    onSearchDelete: function () {
      this.search = ''
      this.fetchContacts(1)
    },

    fetchContacts: function (page = 1) {
      let payload = { uuids: this.contactIds }
      if (this.search) payload.search = this.search
      this.$api.post(`/community-users/contacts/?page=${page}`, payload).then(response => {
        this.contacts = response.data.results
        this.numContacts = response.data.count
        this.numPages = response.data.pages
        this.page = page
      })
    },
  },
}
</script>

<template>

  <div>
    <contact-navbar class="mb-1"
      :search="search"
      @search="onSearchChanged($event)"
      @delete-search="onSearchDelete"
    />

    <div v-if="numContacts > 0">
      <small class="text-muted me-1">{{numContacts}} Treffer</small>

      <div class="list-group mt-1">
        <router-link v-for="contact in contacts" :key="contact.id"
         :to="contactUrl(contact)" class="text-deco-none">
          <contact-entry :contact="contact" />
        </router-link>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages"
        @update:page="fetchContacts($event)" />

    </div>
    <div v-else>
      <div class="text-center mt-5">-- keine Treffer --</div>
    </div>

  </div>
</template>

<style scoped>
.text-deco-none {
  text-decoration: none;
}
</style>
